<template>
  <div class="w-full mx-auto">
    <GMapMap
      :center="center"
      :zoom="16"
      class="w-full h-[400px] rounded-lg shadow-md"
    >
      <!-- Marcadores -->
      <GMapMarker
        v-for="(ponto, index) in coordinates"
        :key="index"
        :position="ponto"
        :icon="getMarkerIcon(index)"
        >
        <GMapInfoWindow :opened="false">
            <div class="text-sm">
            <p class="font-bold">Ponto {{ index + 1 }}</p>
            <p class="text-gray-600">Horário: {{ formattedTime(index) }}</p>
            </div>
        </GMapInfoWindow>
      </GMapMarker>

      <!-- Linha do percurso -->
      <GMapPolyline
        :path="coordinates"
        :options="polylineOptions"
      />
    </GMapMap>
  </div>
</template>

<script>
export default {
  name: 'GoogleMapsRouteComponent',
  props: {
    locations: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    coordinates() {
      return (this.locations || []).map(loc => ({
        lat: parseFloat(loc.latitude),
        lng: parseFloat(loc.longitude),
      }));
    },
    center() {
      const first = (this.locations || [])[0];
      return first
        ? {
            lat: parseFloat(first.latitude),
            lng: parseFloat(first.longitude),
          }
        : { lat: -23.55052, lng: -46.633308 }; // fallback para SP
    }
  },
  methods: {
    getMarkerIcon(index) {
        if (index === 0) {
        return 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'; // início
        }
        if (index === this.locations.length - 1) {
        return 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'; // fim
        }
        return 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'; // intermediários
    },
    formattedTime(index) {
        const raw = this.locations[index]?.captured_at;
        if (!raw) return 'N/A';
        const date = new Date(raw);
        return date.toLocaleString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
        });
    }
    },
  data() {
    return {
      polylineOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 3,
      }
    };
  }
  
};
</script>